import React from "react";
import KmlMapModal from "../Documents/KML/Kml";
import { resolveFileUrl } from "./fileUtils";

const KmlFileViewer = ({ file, open, onClose, projectId }) => {
  const kmlUrl = resolveFileUrl(file, projectId);

  return <KmlMapModal opened={open} onClose={onClose} kmlUrl={kmlUrl} />;
};

export default KmlFileViewer;

